import { render, staticRenderFns } from "./Consumers.vue?vue&type=template&id=4df12a48&scoped=true&"
import script from "./Consumers.vue?vue&type=script&lang=js&"
export * from "./Consumers.vue?vue&type=script&lang=js&"
import style0 from "./Consumers.vue?vue&type=style&index=0&id=4df12a48&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4df12a48",
  null
  
)

export default component.exports